import а from "../assets/russionAudio/а.mp3";
import б from "../assets/russionAudio/б.mp3";
import в from "../assets/russionAudio/в.mp3";
import г from "../assets/russionAudio/г.mp3";
import д from "../assets/russionAudio/д.mp3";
import е from "../assets/russionAudio/е.mp3";
import ё from "../assets/russionAudio/ё.mp3";
import ж from "../assets/russionAudio/ж.mp3";
import з from "../assets/russionAudio/з.mp3";
import и from "../assets/russionAudio/и.mp3";
import й from "../assets/russionAudio/й.mp3";
import к from "../assets/russionAudio/к.mp3";
import л from "../assets/russionAudio/л.mp3";
import м from "../assets/russionAudio/м.mp3";
import н from "../assets/russionAudio/н.mp3";
import о from "../assets/russionAudio/о.mp3";
import п from "../assets/russionAudio/п.mp3";
import р from "../assets/russionAudio/р.mp3";
import с from "../assets/russionAudio/с.mp3";
import т from "../assets/russionAudio/т.mp3";
import у from "../assets/russionAudio/у.mp3";
import ф from "../assets/russionAudio/ф.mp3";
import х from "../assets/russionAudio/х.mp3";
import ц from "../assets/russionAudio/ц.mp3";
import ч from "../assets/russionAudio/ч.mp3";
import ш from "../assets/russionAudio/ш.mp3";
import щ from "../assets/russionAudio/щ.mp3";
import ъ from "../assets/russionAudio/ъ.mp3";
import ы from "../assets/russionAudio/ы.mp3";
import ь from "../assets/russionAudio/ь.mp3";
import э from "../assets/russionAudio/э.mp3";
import ю from "../assets/russionAudio/ю.mp3";
import я from "../assets/russionAudio/я.mp3";

import арбуз from "../assets/russionAudio/арбуз.mp3";
import банан from "../assets/russionAudio/банан.mp3";
import волк from "../assets/russionAudio/волк.mp3";
import гусь from "../assets/russionAudio/гусь.mp3";
import дыня from "../assets/russionAudio/дыня.mp3";
import енот from "../assets/russionAudio/енот.mp3";
import ёлка from "../assets/russionAudio/ёлка.mp3";
import жук from "../assets/russionAudio/жук.mp3";
import зонт from "../assets/russionAudio/зонт.mp3";
import игрушка from "../assets/russionAudio/игрушка.mp3";
import йогурт from "../assets/russionAudio/йогурт.mp3";
import корона from "../assets/russionAudio/корона.mp3";
import лимон from "../assets/russionAudio/лимон.mp3";
import машина from "../assets/russionAudio/машина.mp3";
import нос from "../assets/russionAudio/нос.mp3";
import очки from "../assets/russionAudio/очки.mp3";
import пушка from "../assets/russionAudio/пушка.mp3";
import ракета from "../assets/russionAudio/ракета.mp3";
import солнце from "../assets/russionAudio/солнце.mp3";
import тигр from "../assets/russionAudio/тигр.mp3";
import улитка from "../assets/russionAudio/улитка.mp3";
import фонарь from "../assets/russionAudio/фонарь.mp3";
import хомяк from "../assets/russionAudio/хомяк.mp3";
import цветок from "../assets/russionAudio/цветок.mp3";
import черепаха from "../assets/russionAudio/черепаха.mp3";
import шарик from "../assets/russionAudio/шарик.mp3";
import щетка from "../assets/russionAudio/щетка.mp3";
import сыр from "../assets/russionAudio/сыр.mp3";
import экскаватор from "../assets/russionAudio/экскаватор.mp3";
// import юла from '../assets/russionAudio/юла.mp3'
import якорь from "../assets/russionAudio/якорь.mp3";
import юпка from "../assets/russionAudio/юпка.mp3";

export const russianAlphabet = [
  {
    letter: "А",
    color: "#F06543",
    src: "https://image.flaticon.com/icons/svg/433/433707.svg",
    name: "Арбуз",
  },
  {
    letter: "Б",
    color: "#F99B28",
    src: "https://image.flaticon.com/icons/svg/2293/2293014.svg",
    name: "Банан",
  },
  {
    letter: "В",
    color: "#FEF723",
    src: "https://image.flaticon.com/icons/svg/123/123158.svg",
    name: "Волк",
  },
  {
    letter: "Г",
    color: "#B5D444",
    src: "https://image.flaticon.com/icons/svg/1421/1421596.svg",
    name: "Гусь",
  },
  {
    letter: "Д",
    color: "#0AADE8",
    src: "https://image.flaticon.com/icons/svg/1515/1515045.svg",
    name: "Дыня",
  },
  {
    letter: "Е",
    color: "#EA259D",
    src: "https://image.flaticon.com/icons/svg/1998/1998767.svg",
    name: "Енот",
  },
  {
    letter: "Ё",
    color: "#363190",
    src: "https://image.flaticon.com/icons/svg/629/629570.svg",
    name: "Ёлка",
  },
  {
    letter: "Ж",
    color: "#F9403C",
    src: "https://image.flaticon.com/icons/svg/1850/1850181.svg",
    name: "Жук",
  },
  {
    letter: "З",
    color: "#F5901E",
    src: "https://image.flaticon.com/icons/svg/2357/2357375.svg",
    name: "Зонт",
  },
  {
    letter: "И",
    color: "#FFF11A",
    src: "https://image.flaticon.com/icons/svg/411/411667.svg",
    name: "Игрушка",
  },
  {
    letter: "Й",
    color: "#B7D340",
    src: "https://image.flaticon.com/icons/png/512/2689/2689423.png",
    name: "Йогурт",
  },
  {
    letter: "К",
    color: "#0AADE9",
    src: "https://image.flaticon.com/icons/svg/679/679660.svg",
    name: "Корона",
  },
  {
    letter: "Л",
    color: "#EA008D",
    src: "https://image.flaticon.com/icons/png/512/1998/1998047.png",
    name: "Лимон",
  },
  {
    letter: "М",
    color: "#2E2B92",
    src: "https://image.flaticon.com/icons/svg/741/741407.svg",
    name: "Машина",
  },
  {
    letter: "Н",
    color: "#F6A01A",
    src: "https://image.flaticon.com/icons/svg/1793/1793886.svg",
    name: "Нос",
  },
  {
    letter: "О",
    color: "#F59120",
    src: "https://image.flaticon.com/icons/svg/2768/2768477.svg",
    name: "Очки",
  },
  {
    letter: "П",
    color: "#F8EA13",
    src: "https://image.flaticon.com/icons/png/512/2759/2759764.png",
    name: "Пушка",
  },
  {
    letter: "Р",
    color: "#B3D43A",
    src: "https://image.flaticon.com/icons/svg/2086/2086572.svg",
    name: "Ракета",
  },
  {
    letter: "С",
    color: "#04ACE4",
    src: "https://image.flaticon.com/icons/png/512/826/826955.png",
    name: "Солнце",
  },
  {
    letter: "Т",
    color: "#D9077D",
    src: "https://image.flaticon.com/icons/png/512/375/375073.png",
    name: "Тигр",
  },
  {
    letter: "У",
    color: "#2E2E8C",
    src: "https://image.flaticon.com/icons/png/512/2162/2162091.png",
    name: "Улитка",
  },
  {
    letter: "Ф",
    color: "#ED3131",
    src: "https://image.flaticon.com/icons/svg/2605/2605956.svg",
    name: "Фонарь",
  },
  {
    letter: "Х",
    color: "#F7901B",
    src: "https://image.flaticon.com/icons/svg/1998/1998671.svg",
    name: "Хомяк",
  },
  {
    letter: "Ц",
    color: "#F9F506",
    src: "https://image.flaticon.com/icons/svg/740/740909.svg",
    name: "Цветок",
  },
  {
    letter: "Ч",
    color: "#B7D64A",
    src: "https://image.flaticon.com/icons/svg/616/616651.svg",
    name: "Черепаха",
  },
  {
    letter: "Ш",
    color: "#02AFE8",
    src: "https://image.flaticon.com/icons/svg/1404/1404940.svg",
    name: "Шарик",
  },
  {
    letter: "Щ",
    color: "#F06543",
    src: "https://image.flaticon.com/icons/svg/2877/2877887.svg",
    name: "Щетка",
  },
  {
    letter: "Ъ",
    color: "#F99B28",
    src: "https://image.flaticon.com/icons/svg/2912/2912778.svg",
    name: "Ъ",
  },
  {
    letter: "Ы",
    color: "#FEF723",
    src: "https://image.flaticon.com/icons/svg/517/517612.svg",
    name: "Сыр",
  },
  {
    letter: "Ь",
    color: "#B5D444",
    src: "https://image.flaticon.com/icons/svg/2912/2912778.svg",
    name: "Ь",
  },
  {
    letter: "Э",
    color: "#0AADE8",
    src: "https://image.flaticon.com/icons/svg/2827/2827362.svg",
    name: "Экскаватор",
  },
  {
    letter: "Ю",
    color: "#EA259D",
    src: "https://image.flaticon.com/icons/svg/2161/2161041.svg",
    name: "Юпка",
  },
  {
    letter: "Я",
    color: "#363190",
    src: "https://image.flaticon.com/icons/svg/619/619118.svg",
    name: "Якорь",
  },
];

export const audioRusianAlphabet = {
  А: а,
  Б: б,
  В: в,
  Г: г,
  Д: д,
  Е: е,
  Ё: ё,
  Ж: ж,
  З: з,
  И: и,
  Й: й,
  К: к,
  Л: л,
  М: м,
  Н: н,
  О: о,
  П: п,
  Р: р,
  С: с,
  Т: т,
  У: у,
  Ф: ф,
  Х: х,
  Ц: ц,
  Ч: ч,
  Ш: ш,
  Щ: щ,
  Ъ: ъ,
  Ы: ы,
  Ь: ь,
  Э: э,
  Ю: ю,
  Я: я,
  Арбуз: арбуз,
  Банан: банан,
  Волк: волк,
  Гусь: гусь,
  Дыня: дыня,
  Енот: енот,
  Ёлка: ёлка,
  Жук: жук,
  Зонт: зонт,
  Игрушка: игрушка,
  Йогурт: йогурт,
  Корона: корона,
  Лимон: лимон,
  Машина: машина,
  Нос: нос,
  Очки: очки,
  Пушка: пушка,
  Ракета: ракета,
  Солнце: солнце,
  Тигр: тигр,
  Улитка: улитка,
  Фонарь: фонарь,
  Хомяк: хомяк,
  Цветок: цветок,
  Черепаха: черепаха,
  Шарик: шарик,
  Щетка: щетка,
  Сыр: сыр,
  Экскаватор: экскаватор,
  Юпка: юпка,
  Якорь: якорь,
};
